import { $CombinedState, combineReducers } from 'redux';

import catalogReducer, { ICatalogReducerState } from './catalogReducer';
import catalogVacanciesReducer, { ICatalogVacanciesReducerState } from './catalogVacanciesReducer';
import cityReducer, { ICityReducerState } from './cityReducer';
import divisionReducer, { IDivisionReducerState } from './divisionReducer';
import documentsReducer, { IDocumentsReducerState } from './documentsReducer';
import groupsVacancyReducer, { IGroupsVacancyReducerState } from './groupsVacancyReducer';
import mainReducer, { IMainReducerState } from './mainReducer';
import newsDivisionReducer, { INewsInformationState } from './newsDivisionReducer';
import newsReducer, { INewsResponsesState } from './newsReducer';
import
possibleResponsibleUsersReducer,
{ IPossibleResponsibleUsersReducerState } from './possibleResponsibleUsersReducer';
import roleReducer, { IRoleReducerState } from './roleReducer';
import vacanciesReducer, { IVacanciesReducerState } from './vacanciesReducer';
import vacancyReducer, { IVacancyReducerState } from './vacancyReducer';
import vacancyResponsesReducer, { IVacancyResponsesState } from './vacancyReponsesReducer';

export const RootReducer = combineReducers({
  mainReducer,
  vacancyReducer,
  documentsReducer,
  cityReducer,
  roleReducer,
  catalogReducer,
  catalogVacanciesReducer,
  divisionReducer,
  vacanciesReducer,
  groupsVacancyReducer,
  possibleResponsibleUsers: possibleResponsibleUsersReducer,
  vacancyResponsesReducer,
  newsReducer,
  newsDivisionReducer,
});

export type RootState = {
  readonly [$CombinedState]?: undefined;
} & {
  mainReducer: IMainReducerState;
  vacancyReducer: IVacancyReducerState;
  documentsReducer: IDocumentsReducerState;
  cityReducer: ICityReducerState;
  roleReducer: IRoleReducerState;
  catalogReducer: ICatalogReducerState;
  catalogVacanciesReducer: ICatalogVacanciesReducerState;
  divisionReducer: IDivisionReducerState;
  vacanciesReducer: IVacanciesReducerState;
  groupsVacancyReducer: IGroupsVacancyReducerState;
  possibleResponsibleUsers: IPossibleResponsibleUsersReducerState;
  vacancyResponsesReducer: IVacancyResponsesState;
  newsReducer: INewsResponsesState
  newsDivisionReducer: INewsInformationState
}
